import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@mui/material/Button';

type Props = {
  url: string;
};

export const DetailButton: React.FC<Props> = ({ url }) => {
  return (
    <Button
      variant="contained"
      sx={{
        borderRadius: 5,
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}
      target="_blank"
      href={url}
    >
      イベント詳細を見る（参照URL）
      <OpenInNewIcon fontSize="small" />
    </Button>
  );
};
